import {createContext} from 'react'

export type PlatformContextValue = 'web' | 'native' | 'embed-web' | 'embed-native' | undefined

export const PlatformContext = createContext<PlatformContextValue>(undefined)
